const EMAIL_PATTERN = /^[^@\s]+@[^@\s.]+(?:\.[^@\s.]+)+$/

export const isValidEmail = (value: string): boolean => EMAIL_PATTERN.test(value)
